<button [matMenuTriggerFor]="multiPaymentActions"
        class="absolute-more-btn btn btn-outline-secondary">
    Actions <span *ngIf="payments.length">({{payments.length}})</span> <i class="fa fa-chevron-down"></i>
</button>

<mat-menu #multiPaymentActions="matMenu" yPosition="below">

    <button (click)="exportCsv.emit()" mat-menu-item>
        <span>Download CSV</span>
    </button>

    <div matTooltipPosition="left" [matTooltipDisabled]="payments.length > 0" [matTooltip]="'Select at least payemnt to delete.'">
        <button (click)="deleteOfflinePaymentGroups()" [disabled]="payments.length === 0" *ngIf="hasWriteAccess" mat-menu-item>
            <span>Delete Payments</span>
        </button>
    </div>
    <div matTooltipPosition="left" [matTooltipDisabled]="payments.length > 0" [matTooltip]="'Select at least one deleted payment to archive.'">
        <button (click)="archivePayments()" [disabled]="payments.length === 0" *ngIf="jwt.superUser" mat-menu-item>
            <span>Archive Payments</span>
        </button>
    </div>
</mat-menu>
